import { Field } from '@app/shared/generic-data/generic-data';
export const hasStyling = (column: Field, style: string) =>
  column?.styling?.find((x) => x === style);
